<div class="grid-container">
  <div class="grid-row">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <legend class="usa-legend usa-legend--medium">Local Agents</legend>
    </div>
  </div>
  <form id="carrierLocalAgents" [formGroup]="carrierLocalAgentsForm">
    <div class="grid-row grid-gap">
      
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="agent-scac" class="usa-label">Agent Scac <abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" placeholder="Enter Agent Scac" id="agent-scac" class="usa-input maxw-full" formControlName='agentScac'
            (typeaheadOnSelect)="typeaheadScacOnSelect($event)" [typeaheadScrollable]="true" [typeahead]="typeaheadlist"
            [typeaheadMinLength]="minLengthToSearch" [typeaheadOptionsLimit]="10" [maxlength]="maxCharLength">
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12"></div>
    
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="agent-name" class="usa-label">Agent Name <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" placeholder="Enter Agent Name" id="agent-name" class="usa-input maxw-full" formControlName='agentName'>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="agent-email" class="usa-label">Agent Email <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" placeholder="Enter Agent Email" id="agent-email" class="usa-input maxw-full" formControlName='agentEmail'>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="agent-phone" class="usa-label">Agent Phone <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" placeholder="Enter Agent Phone" id="agent-phone" class="usa-select maxw-full" formControlName='agentPhone'>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
          <label for="agent-status" class="usa-label">Agent Status <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
          <select id="agent-status" class="usa-select maxw-full" formControlName="agentStatus">
            <option [ngValue]="null">..Select a Status..</option>
            <option [ngValue]="agentStatus1" *ngFor="let agentStatus1 of agentStatusList">{{agentStatus1}}</option>
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-4">
          <ul class="usa-button-group">
            <li class="usa-button-group__item">
              <button type="button" class="usa-button usa-button--secondary" *ngIf="!this.isCreate" (click)="onAddButtonClick()"> Reset</button>
            </li>
            <li class="usa-button-group__item">
              <button type="button" class="usa-button" *ngIf="!this.isCreate" (click)="onSaveOrEditClicked('save')">Save</button>
            </li>
          </ul>
        </div>      
    </div>
  </form>
  <div class="grid-row grid-gap">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-y-2" *ngIf="carierLocalAgentsList && carierLocalAgentsList.length>0">
      <span>
        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
          <use xlink:href="/assets/uswds/img/sprite.svg#file_download"></use>
        </svg>
        Right click on the report and select the appropriate options to export.
      </span>
    </div>
    <!-- only show when report is generated -->
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="carierLocalAgentsList && carierLocalAgentsList.length>0">
      <ag-grid-angular class="ag-theme-alpine" 
        [gridOptions]="localAgentsGridOptions" 
        [rowData]="carierLocalAgentsList"
        [suppressDragLeaveHidesColumns]="true"
        ag-grid-resize>
      </ag-grid-angular>
    </div>
  </div>
</div>
<!-- 
<div class="container-fluid py-5">
  <div class="row">
    <div class="col-md-12">
      <div class="card shadow-sm">
        <div class="card-body p-5">
          <h3 class="pt-0 pb-4">Local Agents</h3>
          <form id="carrierLocalAgents" role="form" [formGroup]="carrierLocalAgentsForm">
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="agent-scac">Agent Scac<small class="required">*</small></label>
                <input type="text" placeholder="Enter Agent Scac" id="agent-scac" class="w-100 mr-1"
                  formControlName='agentScac' (typeaheadOnSelect)="typeaheadScacOnSelect($event)"
                  [typeaheadScrollable]="true" [typeahead]="typeaheadlist" [typeaheadMinLength]="minLengthToSearch"
                  [typeaheadOptionsLimit]="10" [maxlength]="maxCharLength">
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="agent-name">Agent Name<small class="required">*</small></label>
                <input type="text" placeholder="Enter Agent Name" id="agent-name" class="w-100"
                  formControlName='agentName'>
              </div>
              <div class="form-group col-md-4">
                <label for="agent-email">Agent Email<small class="required">*</small></label>
                <input type="text" placeholder="Enter Agent Email" id="agent-email" class="w-100"
                  formControlName='agentEmail'>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="agent-phone">Agent Phone<small class="required">*</small></label>
                <input type="text" placeholder="Enter Agent Phone" id="agent-phone" class="w-100"
                  formControlName='agentPhone'>
              </div>
              <div class="form-group col-md-4">
                <label for="agent-status">Agent Status<small class="required">*</small></label>
                <select id="agent-status" class="w-100" formControlName="agentStatus">
                  <option [ngValue]="null">..Select a Status..</option>
                  <option [ngValue]="agentStatus1" *ngFor="let agentStatus1 of agentStatusList">
                    {{agentStatus1}}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-row">
              <button type="button" class="btn btn-outline-secondary w-auto" style="margin: 5px;" *ngIf="!this.isCreate"
                (click)="onAddButtonClick()">
                Reset
              </button>
              <button type="button" class="btn btn-primary w-auto" style="margin-left: 5px;" *ngIf="!this.isCreate"
                (click)="onSaveOrEditClicked('save')">
                Save
            </button>
            </div>
          </form>
        </div>
      </div>
      <ag-grid-angular class="ag-theme-alpine" [gridOptions]="localAgentsGridOptions" [rowData]="carierLocalAgentsList"
        [suppressDragLeaveHidesColumns]="true">
      </ag-grid-angular>
    </div>
  </div>
</div> -->